export const getTypeLabel = (type: string) => {
    const labels: Record<string, string> = {
        text: 'Texto',
        image: 'Imagem',
        video: 'Vídeo',
        audio: 'Áudio',
        voice: 'Voz'
    };
    return labels[type] || type;
};